import { render } from "./About.vue?vue&type=template&id=4c538472&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=4c538472&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c538472"

export default script